import { ErrorCodes } from '@clinikchat/shared';

type ApiErr = {
  response?: { status?: number; data?: { error?: { code?: string; message?: string } } };
};

export function invitePreviewMessage(err: unknown): string {
  const ax = err as ApiErr;
  const code = ax.response?.data?.error?.code;
  const status = ax.response?.status;

  if (code === ErrorCodes.INVITE_EXPIRED || status === 410) {
    return 'This invite has expired. Ask your workspace admin to send you a new link.';
  }
  if (code === ErrorCodes.INVITE_EXHAUSTED) {
    return 'This invite has already been used as many times as allowed. Ask your admin for a new invite.';
  }
  if (code === ErrorCodes.INVITE_INVALID || status === 400) {
    return 'This invite code is not valid. Double-check the link or ask your admin to resend it.';
  }
  if (code === ErrorCodes.INVITE_NOT_FOUND || status === 404) {
    return 'We could not find this invite. It may have been revoked or the link might be wrong.';
  }
  return 'We could not verify this invite. Check your connection or ask your admin for a new link.';
}

export function joinSubmitMessage(err: unknown): string {
  const ax = err as ApiErr;
  const code = ax.response?.data?.error?.code;
  const status = ax.response?.status;
  const server = ax.response?.data?.error?.message;

  if (code === ErrorCodes.RATE_LIMIT_EXCEEDED || status === 429) {
    return 'Too many sign-up attempts from your network. Please wait about a minute and try again.';
  }
  if (code === ErrorCodes.AUTH_EMAIL_TAKEN) {
    return 'An account already exists with this email. Sign in instead, or use a different email.';
  }
  if (code === ErrorCodes.INVITE_EXPIRED || status === 410) {
    return 'This invite has expired. Ask your admin for a new invite link.';
  }
  if (code === ErrorCodes.INVITE_EXHAUSTED) {
    return 'This invite is no longer available — it has reached its use limit. Ask your admin for a new invite.';
  }
  if (code === ErrorCodes.INVITE_NOT_FOUND || status === 404) {
    return 'This invite is no longer valid. It may have been revoked. Ask your admin for a new link.';
  }
  if (code === ErrorCodes.INVITE_INVALID) {
    return 'This invite code is not valid. Open the invite link from your email again.';
  }
  if (code === ErrorCodes.ORG_MEMBER_EXISTS) {
    return 'You are already a member of this organization. Sign in to continue.';
  }
  return server || 'Something went wrong while creating your account. Please try again.';
}

export function inviteJoinUrl(origin: string, code: string): string {
  const base = origin.replace(/\/$/, '');
  return `${base}/join?code=${encodeURIComponent(code)}`;
}
